import React, { ChangeEvent } from 'react';
import styles from './PaymentInfo.module.scss';

function Input(props: {
  type: string;
  name: string;
  value: any;
  label: string;
  placeholder: string;
  handleInput: (event: ChangeEvent<HTMLInputElement>) => void;
  error: null | string;
  additionalCss?: string;
  dataRecurly?: string;
  hidden?: boolean;
}) {
  const {
    type, name, value, label, placeholder, handleInput, error, additionalCss, dataRecurly, hidden,
  } = props;

  return (
    <label htmlFor={name} className={styles.label} hidden={hidden}>
      {label}
      <input
        type={type}
        className={`${styles.input} ${additionalCss} ${error !== null ? styles.inputError : ''}`}
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={handleInput}
        data-recurly={dataRecurly}
      />
    </label>
  );
}

Input.defaultProps = {
  additionalCss: '',
  dataRecurly: '',
  hidden: false,
};

export default Input;
